import { render, staticRenderFns } from "./paydetailrecord.vue?vue&type=template&id=a63456c8&"
import script from "./paydetailrecord.vue?vue&type=script&lang=js&"
export * from "./paydetailrecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports